import React, { useState, useContext }from 'react';
import { useIonRouter, IonContent, IonHeader, IonFooter, IonTitle, IonToolbar, IonMenuButton, IonButtons, IonButton, IonItem, IonGrid, IonRow, IonCol, IonInput, IonLabel, IonPage, IonList, IonIcon, IonRefresher, IonRefresherContent  } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';

//import { SelectDateRange } from '../components/SelectDateRange';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
import { App_Header } from '../components/App_Header_ProService';
//import { App_Footer } from '../components/App_Footer';

import '../../../css/layout.css';
import { OverviewBusinessSlides } from '../components/Tab_Overview';
import { Tab_Projects } from '../components/Tab_Projects';
import { ProService_Management } from '../components/proService_management_services';
//import { CleaningServicesSlides } from '../components/Tab_CleaningServices';
//import { ReservationSlides } from '../components/Tab_Reservations';
import { Helpdesk_Public } from '../../../zInternal_Features/merchant/components/Modal_HelpChat_Public';

import { useHistory} from "react-router-dom";

 export function ProService_MerchantHomePage () {

    let authMerchant_objects = useContext(Auth_MerchantID_context);

    let [acctID, setAccountID ] = useState(authMerchant_objects.acctID);
    let [employeeID, setEmployeeID ] = useState(authMerchant_objects.employeeID);
    let [schema, setSchema ] = useState(authMerchant_objects.schema);
    let [access, setAccessRights ] = useState(authMerchant_objects.accessRights);
    let [baseURL, setBaseURL ] = useState(authMerchant_objects.baseURL);


    let [overviewData, setOverviewData] = useState(false);
    let [projectsSlideData, setProjectsSlideData] = useState(true);
    // let [cleaningServicesData, setCleaningServicesData] = useState(false);
    // let [reservationsData, setReservationsData] = useState(false);
    // let [restaurantData, setRestaurantData] = useState(false);

    let [color_overview, setColor_overview] = useState('clear')
    let [color_projects, setColor_projects] = useState('outline')
    // let [color_cleaningServices, setColor_cleaningServices] = useState('clear')
    // let [color_reservations, setColor_reservations] = useState('clear')
    // let [color_restaurant, setColor_restaurant] = useState('clear')
    let [viewHelpDeskModal, setViewHelpDeskModal] = useState(false);

    let [managementService_proService, setManagementService_proService] = useState(false);

    let history = useHistory();
    let router = useIonRouter();

    function overviewHandler()
    {
        setOverviewData(true);
        setProjectsSlideData(false);
        //setCleaningServicesData(false);
        //setReservationsData(false);

        setColor_overview('outline');
        setColor_projects('clear');
        //setColor_cleaningServices('clear');
        //setColor_reservations('clear');


    }
    function checkInCheckOutHandler()
    {
        setOverviewData(false);
        setProjectsSlideData(true);
        //setCleaningServicesData(false);
        //setReservationsData(false);

        setColor_overview('clear');
        setColor_projects('outline');
        //setColor_cleaningServices('clear');
        //setColor_reservations('clear');

    }

    // function cleaningServicesHandler()
    // {
    //     setOverviewData(false);
    //     setCheckInCheckOutData(false);
    //     setCleaningServicesData(true);
    //     setReservationsData(false);

    //     setColor_overview('clear');
    //     setColor_checkInCheckOut('clear');
    //     setColor_cleaningServices('outline');
    //     setColor_reservations('clear');

    // }

    // function reservationsHandler()
    // {
    //     setOverviewData(false);
    //     setCheckInCheckOutData(false);
    //     setCleaningServicesData(false);
    //     setReservationsData(true);

    //     setColor_overview('clear');
    //     setColor_checkInCheckOut('clear');
    //     setColor_cleaningServices('clear');
    //     setColor_reservations('outline');

    // }


    const handleHomepage_zasava = () => {


        if (baseURL === "https://ghanaverified.com/") {
            window.location.href = "https://zasava.com";
            //history.push("https://zasava.com");

        } 
        else if (baseURL === "https://ghanaverifiedtest.com/") {
            window.location.href = "https://zasavatest.com";
           // history.push("https://zasavatest.com");
        }
  };

  function handleHomepage(event) {

    // alert(event);
    // alert(window.location.pathname)

        // history.push(event);
        router.push(event, 'forward', 'replace');
        //window.location = event;
    };


    function handleRefresh(event)
    {
        // Optional: Delay to show the spinner briefly
        setTimeout(() => {
            event.detail.complete();   // Stop the spinner
            window.location.reload();  // Reload the entire app
        }, 500);
    }
    

    //alert('In Hotel_MerchantHomePage');   
    //alert(acctID);
    //alert(employeeID);
    //alert(schema);
    //alert(access);
    //alert(authMerchant_objects.accessRights);

    return (
            <React.Fragment>

                <IonContent fullscreen>

                <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
                    <IonRefresherContent
                    pullingText="Pull to refresh the app"
                    refreshingSpinner="circles"
                    refreshingText="Refreshing app..."
                    />
                </IonRefresher>

                <IonHeader>

                <IonGrid className='grid_header'>
                        {authMerchant_objects.authenticated != null && <IonRow>
                        <IonCol style={{ textAlign: 'left', color: 'white' }} size='4'>
                            <IonTitle >{authMerchant_objects.employeeCompany}</IonTitle>
                        </IonCol>
                        <IonCol style={{ textAlign: 'left', color: 'white' }} size='6'>
                            <IonTitle >{authMerchant_objects.employeeFirstName + ' ' + authMerchant_objects.employeeLastName}</IonTitle>
                        </IonCol>
                        <IonCol className='gh_top_links_col_right' size='2'>
                            <IonMenuButton menu="side_menu_hotel" className="custom-menu-button"  fill={'clear'}>M</IonMenuButton>
                        </IonCol>
                    </IonRow>}
                    <IonRow>
                        <IonCol size = '6'>
                            <IonButton className= 'medium-button-tabs' fill={color_overview} onClick={() => overviewHandler()}> Overview </IonButton>
                        </IonCol>
                        <IonCol size = '6'>
                            <IonButton className= 'medium-button-tabs' fill={color_projects} onClick={() => checkInCheckOutHandler()}> Projects </IonButton>
                        </IonCol>
                        {/*<IonCol size = '3'>
                            <IonButton className= 'small-button-tabs' fill={color_reservations} onClick={() => reservationsHandler()}> Reports </IonButton>
                        </IonCol>*/}
                    </IonRow>
                </IonGrid>

                </IonHeader>


                   {overviewData == true && <OverviewBusinessSlides openModal={ overviewData } closeModal={() => setOverviewData(false)}></OverviewBusinessSlides>}
                   {projectsSlideData == true && <Tab_Projects openModal={ projectsSlideData } closeModal={() => setProjectsSlideData(false)}></Tab_Projects>}   
                    {/*{cleaningServicesData == true && <CleaningServicesSlides openModal={ cleaningServicesData } closeModal={() => setCleaningServicesData(false)}></CleaningServicesSlides>}
                        reservationsData == true && <ReservationSlides openModal={ reservationsData } closeModal={() => setReservationsData(false)}></ReservationSlides>}    */}

                    {managementService_proService == true && <ProService_Management openModal={managementService_proService} closeModal={() => setManagementService_proService(false)}></ProService_Management>}

                    {viewHelpDeskModal == true && <Helpdesk_Public openModal={viewHelpDeskModal} closeModal={() => setViewHelpDeskModal(false)}></Helpdesk_Public>}

                <IonFooter className='grid_footer'>
                        <IonGrid>
                            <IonRow>
                                <IonCol size='2'>
                                    <IonButton className="custom-help-button" fill={'clear'} onClick={() => setViewHelpDeskModal(true)}>H</IonButton>
                                </IonCol>
                                <IonCol size='8'>
                                    {(authMerchant_objects.accessRights[0] == 'admin' || authMerchant_objects.accessRights[0] == 'manager') &&  
                                        <IonButton  className='small_button' auto-hide='false' onClick={ () => setManagementService_proService(true)} >Management</IonButton> 
                                    }
                                </IonCol>
                                <IonCol size='2'>
                                    <IonButton className="custom-public-button" fill={'clear'} onClick={() => handleHomepage('/home')}>P</IonButton>
                                </IonCol>
                            </IonRow>
                          {/*  {(authMerchant_objects.authenticated != null && (authMerchant_objects.acctID == "G1" || authMerchant_objects.acctID == "G27" || authMerchant_objects.acctID == "G23")) &&
                                <IonRow>
                                    <IonCol size='12'>
                                        <IonButton className='small_button' onClick={() => handleHomepage_zasava()}>Zasava</IonButton>
                                    </IonCol>
                                 </IonRow>
                                } */}
                        </IonGrid>

                </IonFooter>

            </IonContent>
            </React.Fragment>

    );
};



export default ProService_MerchantHomePage;